import Constants from 'expo-constants'

export const API_URL = Constants.manifest?.extra?.apiUrl
